import { BiMinus, BiPlus, BiSquare } from 'react-icons/bi';
import { arithmeticMathKeysFromLabel } from '../../../../../../../../../consts/operators';
import { LuDivide } from 'react-icons/lu';
import { IoClose } from 'react-icons/io5';

const icons = {
  '+': BiPlus,
  '-': BiMinus,
  x: IoClose,
  '÷': LuDivide,
  empty: BiSquare
};

export const ArithmeticSymbol = ({ type, value }) => {
  if (type === 'condition')
    return value ? (
      <p id="grid-table-arithmetic-symbol-condition" className="condition">
        {value}
      </p>
    ) : (
      <></>
    );

  const Icon = icons[arithmeticMathKeysFromLabel[value] || 'empty'];

  return <Icon id="grid-table-arithmetic-symbol-icon" color="#40C057" fontSize="20px" />;
};
